import React, { useState, useEffect } from "react"
import {
  Card,
  Button,
  Input,
  Table,
  Select,
  Dropdown,
  Icon,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import EditingTerminal from "./EditingTerminal"
import { apiDelete, apiPut } from "../utils/apiConnector"
import { terminalApi } from "../config/apiUrls"

const TerminalInner = (props) => {
  const { t } = useTranslation()
  const { terminal, getTerminals, setModal, lines } = props
  const [edit, setEdit] = useState(false)
  const [place, setPlace] = useState(terminal.place)
  const [name, setName] = useState(terminal.name)
  const [line, setLine] = useState(terminal.line)
  const [mode, setMode] = useState(terminal.mode)
  const [storage, setStorage] = useState(terminal.storage)
  const handleSubmit = () => {
    const req = { name, id: terminal.id }
    apiPut(terminalApi, req)
      .onOk((res) => {
        console.log(res)
      })
      .onFail(() => {})
      .afterAll(() => {})
      .startSingle()
  }
  return (
    <>
      <div>
        <Card fluid>
          <Card.Content>
            {edit ? (
              <>
                <EditingTerminal
                  place={place}
                  setPlace={setPlace}
                  name={name}
                  setName={setName}
                  line={line}
                  setLine={setLine}
                  mode={mode}
                  setMode={setMode}
                  storage={storage}
                  setStorage={setStorage}
                  terminal={terminal}
                  handleSubmit={handleSubmit}
                  getTerminals={getTerminals}
                  lines={lines}
                />
              </>
            ) : (
              <>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <h3 style={{ marginRight: 10 }}>
                      <b>{t("Device")}</b>
                    </h3>
                    <Icon
                      name="edit"
                      size="big"
                      onClick={() => {
                        setEdit(!edit)
                      }}
                    />
                    <Icon
                      name="trash"
                      size="big"
                      onClick={() => {
                        apiDelete(terminalApi + "/" + terminal.id)
                          .onOk((res) => {
                            console.log(res)
                            getTerminals()
                          })
                          .onFail(() => {})
                          .afterAll(() => {
                            setModal(false)
                          })
                          .startSingle()
                      }}
                    />
                  </div>
                  <div>
                    <Table fluid style={{ border: "0px solid red" }}>
                      <Table.Body>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Идентификатор</b>
                          </Table.Cell>
                          <Table.Cell>{terminal.ident}</Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Рабочее место</b>
                          </Table.Cell>
                          <Table.Cell>{terminal.place}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("Name")}</b>
                          </Table.Cell>
                          <Table.Cell>{terminal.name}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <b>ID</b>
                          </Table.Cell>
                          <Table.Cell>{terminal.id}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("Line")}</b>
                          </Table.Cell>
                          <Table.Cell>{terminal.line}</Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Режим работы устройства</b>
                          </Table.Cell>
                          <Table.Cell>{terminal.mode}</Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Локальный сервер</b>
                          </Table.Cell>
                          <Table.Cell>
                            {terminal.local ? "Включено" : "Выключено"}
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Склад</b>
                          </Table.Cell>
                          <Table.Cell>{terminal.storage}</Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Печатать несколько этикеток для паллеты</b>
                          </Table.Cell>
                          <Table.Cell>
                            {terminal.printMore ? (
                              <Icon name="check" color="green" />
                            ) : (
                              <Icon name="close" color="red" />
                            )}
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Версия приложения</b>
                          </Table.Cell>
                          <Table.Cell>{terminal.ver}</Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Порядковый номер</b>
                          </Table.Cell>
                          <Table.Cell>{terminal.orderNumber}</Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Сотрудник</b>
                          </Table.Cell>
                          <Table.Cell>
                            {terminal.employee
                              ? "name"
                              : "Сотрудник не назначен"}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </div>
                </div>
              </>
            )}
          </Card.Content>
        </Card>
      </div>
    </>
  )
}

export default TerminalInner
